import React from 'react';
import type { StoreState } from './useValuesStore';
import type { MetaState } from './useMetaStore';

export default React.createContext<{ values: StoreState; meta: MetaState }>({ values: {}, meta: {} } as any);
